/**
 * A reward's item as a two-letter tile in a hue derived from the item id, so two `rare_candy` rows
 * look alike and a `diamond` row does not. No item textures ship with this SPA (the registry dump the
 * editor uses is a staff surface), and inventing a coloured square per item is honest about that where
 * a generic grey box would just look broken.
 *
 * The PLAYER is no longer a tile here: Stats' header shows the same face as the Music app's player
 * card (`audio/parts.tsx` `PlayerHead`), drawn from the claim's skin hash, or generated from the uuid
 * as pixels — never from the uuid's characters.
 */
import { hueOf } from './identity';

export function ItemGlyph({ itemId, initials }: { itemId: string | null; initials: string }): React.JSX.Element {
  const hue = itemId === null ? 30 : hueOf(itemId);
  return (
    <span className="me-glyph" style={{ '--me-avatar-hue': String(hue) } as React.CSSProperties} aria-hidden="true">
      {initials}
    </span>
  );
}
